import React from "react";
import Utils from "Utils/utils";
import { ReactComponent as FileIcon } from "Assets/svg/bulkCsvConnect/file.svg";
import { ReactComponent as CheckmarkIcon } from "Assets/svg/bulkCsvConnect/checkmark.svg";

const SKIPPED_STATUSES = ["DUPLICATE", "GENERIC_DOMAIN", "DOMAIN_MISSING", "FAILED"];

const REASON_LABELS = {
  DUPLICATE: "Duplicate domain",
  GENERIC_DOMAIN: "Generic domain",
  DOMAIN_MISSING: "Domain missing",
  FAILED: "Failed"
};

const getAccountCsvErrorLabel = (row = {}) => {
  const { status = "", errorReason = "" } = row || {};
  return errorReason || REASON_LABELS[status] || "Skipped";
};

const AccountImportRowDetail = (props = {}) => {
  const { job = {}, rows = null, loading = true } = props || {};
  const {
    fileName = "",
    status = "",
    totalCount = 0,
    successCount = 0,
    failedCount = 0,
    createTs = "",
    owner = {}
  } = job || {};

  const isInProgress = ["TO_BE_PROCESSED", "IN_PROGRESS"].includes(status);
  const pct = totalCount > 0 ? Math.round((successCount / totalCount) * 100) : 0;
  const hasSkippedRows = failedCount > 0;
  const skippedRows = (rows || []).filter(row => SKIPPED_STATUSES.includes(row?.status));

  return (
    <div className="inboxImportDetailPanel">
      <div className="inboxImportDetailTop">
        <div className="inboxImportDetailLeft">
          <div className="inboxImportDetailLabel">File</div>
          <div className="inboxImportFileRow">
            <span className="inboxImportFileIcon">
              <FileIcon />
            </span>
            <div>
              <div className="inboxImportFileName">{fileName || "--"}</div>
              <div className="inboxImportFileMeta">
                {totalCount} rows · {createTs ? Utils.getDateFromString(createTs) : "--"}
              </div>
            </div>
          </div>
          <div className="inboxImportMetaCols">
            <div>
              <div className="inboxImportDetailLabel">Created</div>
              <div className="inboxImportMetaValue">
                {createTs ? Utils.getDateFromString(createTs) : "--"}
              </div>
            </div>
            <div>
              <div className="inboxImportDetailLabel">Owner</div>
              <div className="inboxImportMetaValue">{Utils.getOwnerName(owner) || "--"}</div>
            </div>
          </div>
        </div>

        <div className="inboxImportDetailRight">
          <div className="inboxImportDetailLabel">Summary</div>
          <div className="inboxImportStatCards">
            <div className="inboxImportStatCard">
              <div className="inboxImportStatLabel">Total</div>
              <div className="inboxImportStatValue">{totalCount}</div>
            </div>
            <div className="inboxImportStatCard connected">
              <div className="inboxImportStatLabel">Created</div>
              <div className="inboxImportStatValue">{successCount}</div>
            </div>
            <div className={`inboxImportStatCard ${failedCount > 0 ? "skipped" : ""}`}>
              <div className="inboxImportStatLabel">Skipped</div>
              <div className="inboxImportStatValue">{failedCount}</div>
            </div>
          </div>

          {!isInProgress ? (
            <div className="inboxImportProgressRow">
              <div className="inboxImportProgressLabelRow">
                <span>Creation rate</span>
                <span className={pct === 100 ? "full" : ""}>{pct}%</span>
              </div>
              <div className="inboxImportProgressTrack">
                <div className="inboxImportProgressFill" style={{ width: `${pct}%` }} />
              </div>
            </div>
          ) : (
            <div className="inboxImportInProgressNote">
              <span className="inboxImportPulseDot" />
              Import in progress — this may take a few minutes.
            </div>
          )}
        </div>
      </div>

      {hasSkippedRows && (
        <div className="inboxImportSkippedSection">
          <div className="inboxImportSkippedHeader">
            <span>
              Skipped accounts
              <span className="inboxImportSkippedCount">{failedCount}</span>
            </span>
          </div>
          {loading ? (
            <div className="inboxImportSkippedLoading">Loading skipped accounts...</div>
          ) : (
            <div className="bulkCsvTableWrapper">
              <table>
                <thead>
                  <tr>
                    <th>Domain</th>
                    <th>Name</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {skippedRows.map((row, index) => (
                    <tr key={`${row.domain}-${index}`}>
                      <td>{row.domain || "--"}</td>
                      <td>{row.name || "--"}</td>
                      <td className="inboxImportReasonCell">{getAccountCsvErrorLabel(row)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {!hasSkippedRows && !isInProgress && (
        <div className="inboxImportAllConnected">
          <CheckmarkIcon />
          All accounts created successfully.
        </div>
      )}
    </div>
  );
};

export default AccountImportRowDetail;
export { AccountImportRowDetail };
